import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "customer-ratings-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "basic-table table-responsive" }
const _hoisted_5 = { class: "table mb-0" }
const _hoisted_6 = { class: "fw-semibold text-body" }
const _hoisted_7 = { class: "employee-info d-flex align-items-center" }
const _hoisted_8 = { class: "img rounded-circle" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d-block fw-semibold" }
const _hoisted_11 = { class: "fw-semibold text-body" }
const _hoisted_12 = { class: "ratings lh-1" }
const _hoisted_13 = { class: "d-inline-block lh-1 text-xs text-body" }
const _hoisted_14 = { class: "reviews" }
const _hoisted_15 = { class: "reviews" }
const _hoisted_16 = { class: "d-block fw-semibold" }
const _hoisted_17 = { class: "fw-semibold text-body" }
const _hoisted_18 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap pt-3" }
const _hoisted_19 = { class: "fs-12 fw-medium" }
const _hoisted_20 = { "aria-label": "Page navigation example" }
const _hoisted_21 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_22 = { class: "page-item" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "page-item" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mb-lg-20" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Customer Ratings"),
        _createElementVNode("select", {
          class: "form-select month-select bg-gray border-0 form-control",
          "aria-label": "Default select example"
        }, [
          _createElementVNode("option", { selected: "" }, "Weekly"),
          _createElementVNode("option", null, "Monthly"),
          _createElementVNode("option", null, "Yearly")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "User ID"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Customer Name"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Ratings"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Reviews"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Date"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                })
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedRatings, (rating) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: rating.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(rating.id), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: rating.image,
                          alt: "user-image",
                          class: "rounded-circle"
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(rating.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-star-fill" }, null, -1)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(rating.rating), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(rating.reviewTitle), 1),
                      _createElementVNode("p", null, _toDisplayString(rating.review), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(rating.date), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "action-buttons d-flex justify-content-end align-items-center" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, " visibility ")
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, " edit ")
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, " delete ")
                      ])
                    ])
                  ], -1))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, " Showing " + _toDisplayString(_ctx.startIndex + 1) + " to " + _toDisplayString(_ctx.endIndex) + " of " + _toDisplayString(_ctx.ratings.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_20, [
            _createElementVNode("ul", _hoisted_21, [
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_23)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_24)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_26)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}